import { JSONApiDataObject, Notification, NotificationType } from 'Douleutaras/types';
import moment from 'moment';

export interface UnreadDailyWeekly {
  unreadDaily: number;
  unreadWeekly: number;
  unreadDailyIds: Array<string>;
  unreadWeeklyIds: Array<string>;
}

export const calculateUnreadDailyWeekly = (
  notifications: Array<JSONApiDataObject<Notification>> = []
): UnreadDailyWeekly => {
  let unreadDaily = 0;
  let unreadWeekly = 0;
  const unreadDailyIds = [];
  const unreadWeeklyIds = [];

  notifications.forEach(notification => {
    if (notification.attributes.isNew && !notification.attributes.isRead) {
      switch (notification.attributes.notificationType) {
        case NotificationType.DAILY:
          unreadDaily += 1;
          unreadDailyIds.push(notification.id);
          break;
        case NotificationType.WEEKLY:
          unreadWeekly += 1;
          unreadWeeklyIds.push(notification.id);
          break;
        default:
      }
    }
  });

  return {
    unreadDaily,
    unreadWeekly,
    unreadDailyIds,
    unreadWeeklyIds
  };
};

export const checkSummaryCondition = (
  notifications: Array<JSONApiDataObject<Notification>> = []
): { isTimeRight: boolean; type?: NotificationType; id?: string; redirect?: string; } => {
  const defaultRes = {
    isTimeRight: false
  };
  const unread = calculateUnreadDailyWeekly(notifications);

  const now = new Date();
  const isSunday = now.getDay() === 0;

  // If there is no unread daily messages then do nothing.
  if (!isSunday && unread.unreadDaily < 1) {
    return defaultRes;
  }
  // If there is no unread weekly messages then do nothing.
  if (isSunday && unread.unreadWeekly < 1) {
    return defaultRes;
  }

  const type = isSunday ? NotificationType.WEEKLY : NotificationType.DAILY;
  const topHours = 24;
  const isTimeRight = moment(now)
    .isBetween(now.setHours(8, 30, 0, 0), now.setHours(topHours, 0, 0, 0));
  const id = type === NotificationType.DAILY && unread.unreadDailyIds.length
    ? unread.unreadDailyIds[0]
    : type === NotificationType.WEEKLY && unread.unreadWeeklyIds.length
      ? unread.unreadWeeklyIds[0]
      : undefined;
  const redirect = `/dashboard-v2/pro/${type.replace('_', '-')}`;

  return {
    isTimeRight,
    redirect,
    type,
    id
  };
};
